module.exports = __webpack_public_path__ + "img/img10.4c727d8d.png";